import React, { useRef, useState } from "react";
import Swal from "sweetalert2";

export const FormContacto = ({ taller, handleClose }) => {
  const form = useRef();
  const [nov, setNov] = useState(true);

  const sendEmail = async (e) => {
    e.preventDefault();

    const formData = new FormData(form.current);

    try {
      const response = await fetch("send_email.php", {
        method: "POST",
        body: formData,
      });

      const text = await response.text();
      console.log("Respuesta del servidor:", text);

      if (response.ok) {
        // ✅ Limpiar el formulario ANTES de cerrarlo
        form.current.reset();
        setNov(true);

        // ✅ Cerrar el modal
        handleClose();

        // ✅ Mostrar SweetAlert después de cerrar el modal
        setTimeout(() => {
          Swal.fire({
            text: "¡Gracias por contactarnos!",
            iconHtml: `<img src="/ean.jpg" alt="Icono personalizado" width="100"/>`,
            confirmButtonText: "Ok",
            customClass: {
              icon: "custom-icon-class",
              confirmButton: "boton",
            },
          });
        }, 300);
      } else {
        Swal.fire({
          icon: "error",
          title: "Ups...",
          text: "Hubo un problema al enviar el mensaje. Intenta nuevamente más tarde.",
          customClass: {
            confirmButton: "boton",
          },
        });
        console.error("Error al enviar el correo:", text);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      Swal.fire({
        icon: "error",
        title: "Error de conexión",
        text: "No pudimos enviar el formulario. Verifica tu conexión o inténtalo más tarde.",
        customClass: {
          confirmButton: "boton",
        },
      });
    }
  };

  const handleNovChange = (e) => {
    setNov(e.target.checked);
  };

  return (
    <form id="form" ref={form} onSubmit={sendEmail}>
      <div className="formulario2">
        <label>Nombre</label>
        <input type="text" name="name" required />

        <label>Email</label>
        <input type="email" name="email" required />

        <label>Celular</label>
        <input type="number" name="telefono" required />

        <label>Mensaje</label>
        <textarea name="message" rows={5} />

        <div className="d-flex mt-4 mb-2">
          <input type="hidden" name="taller" value={taller} />

          <label className="custom-checkbox">
            <input
              type="checkbox"
              name="nov"
              checked={nov}
              onChange={handleNovChange}
            />
            <input
              type="hidden"
              name="nov_message"
              value={
                nov
                  ? "Quiero recibir novedades Espacio Analógico"
                  : "No se suscribió"
              }
            />
            <span className="checkmark ms-2"></span>
            <span className="ms-4 labelCheck">
              Quiero recibir novedades de Espacio Analógico
            </span>
          </label>
        </div>

        <div className="col-12 text-center">
          <input className="boton" type="submit" value="Enviar" />
        </div>
      </div>
    </form>
  );
};
